import { Spinner } from 'reactstrap';

export const LoadingAnimation = (props) => {
  return <Spinner data-testid="loading-animation" {...props} />;
};

export default LoadingAnimation;
